import palette from './palette';

export default {
  fontFamily: 'Poppins',

  h1: {
    color: palette.text.primary,
    fontWeight: '500',
    // fontSize: '35px',
    letterSpacing: '-0.24px',
    // lineHeight: '40px'
  },
  h2: {
    color: palette.text.primary,
    fontWeight: '500',
    // fontSize: '29px',
    letterSpacing: '-0.24px',
    // lineHeight: '32px'
  },
  h3: {
    color: palette.text.primary,
    fontWeight: '600',
    fontSize: '24px',
    letterSpacing: '-0.06px',
    lineHeight: '28px',
  },
  h4: {
    color: palette.text.primary,
    fontWeight: '500',
    // fontSize: '20px',
    letterSpacing: '-0.06px',
    // lineHeight: '24px'
  },
  h5: {
    color: palette.text.primary,
    fontWeight: '600',
    // fontSize: '16px',
    letterSpacing: '-0.3px',
    // lineHeight: '20px'
  },
  h6: {
    color: palette.text.primary,
    fontWeight: '500',
    // fontSize: '14px',
    letterSpacing: '-0.3px',
    // lineHeight: '20px',
  },
  subtitle1: {
    color: palette.text.primary,
    // fontSize: '16px',
    letterSpacing: '-0.3px',
    // lineHeight: '25px'
  },
  subtitle2: {
    color: palette.text.primary,
    // fontSize: '14px',
    letterSpacing: 0,
    // lineHeight: '16px'
  },
  body: {},
  body1: {
    fontWeight: 'normal',
    color: palette.text.primary,
    // fontSize: '14px',
    letterSpacing: '-0.3px',
    // lineHeight: '21px'
  },
  body2: {
    color: palette.text.primary,
    fontWeight: 'normal',
    // fontSize: '12px',
    letterSpacing: '-0.04px',
    // lineHeight: '14px'
  },
  button: {
    color: palette.text.primary,
    fontWeight: 'normal',
    // fontSize: '14px'
  },
  caption: {
    color: palette.text.secondary,
    fontWeight: 'normal',
    // fontSize: '12px',
    letterSpacing: '0.3px',
    // lineHeight: '16px'
  },
};
